import Collection from '../../collection';
import Sticker from '../../model/sticker';

export default Collection.extend( {
	endpoint: 'sticker/list',
	responseAt: 'stickers',
    model: Sticker
} );


// WEBPACK FOOTER //
// ./src/js/collection/refbooks/stickers.js